import { render, staticRenderFns } from "./SyncModuleLayout.vue?vue&type=template&id=2026119a&"
import script from "./SyncModuleLayout.vue?vue&type=script&lang=js&"
export * from "./SyncModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports